import React, { useState } from "react";
import FormDateTimeColumn from "../../components/Employee/OfficialBusiness/FormDateTimeColumn";
import ReasonField from "../../components/Employee/OfficialBusiness/ReasonField";
import FileUpload from "../../components/Employee/OfficialBusiness/FileUpload";
import { useCreateMedia } from "../../hooks/useMedia";
import { EMPLOYEE_MEDIA_REFERENCE } from "../../util/common";
import { useCreateOfficialBusiness } from "../../hooks/useAttendance";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

function BusinessApplicationLayout() {
  const fileMediaUpload = useCreateMedia();
  const officialBusiness = useCreateOfficialBusiness();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    obDateFrom: "",
    obDateTo: "",
    obTimeFrom: "",
    obTimeTo: "",
    reason: "",
    mediaID: null,
  });

  const [fileAttached, setFileAttached] = useState(null);

  const handleChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileUpload = async () => {
    if (!fileAttached) return null;

    const formDataFile = new FormData();
    formDataFile.append("ReferenceType", EMPLOYEE_MEDIA_REFERENCE);
    formDataFile.append("File", fileAttached);

    return new Promise((resolve, reject) => {
      fileMediaUpload.mutate(formDataFile, {
        onSuccess: (data) => {
          if (data.success) {
            resolve(data?.data?.id);
          } else {
            resolve(null);
          }
        },
        onError: (err) => {
          reject(err);
        },
      });
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let mediaID = null;

    if (fileAttached) {
      mediaID = await handleFileUpload();
    }

    const finalPayload = {
      ...formData,
      mediaID: mediaID,
    };

    officialBusiness.mutate(finalPayload, {
      onSuccess: (data) => {
        if (data && data.success) {
          toast.success(data.message);
          return navigate("/BusinessList");
        }
      },
      onError: (er) => {
        return toast.error("Error occurred");
      },
    });
  };

  return (
    <div className="overtime-form-container">
      <h2>Business Application Form</h2>

      <form className="overtime-form" onSubmit={handleSubmit}>
        {/* Left Column */}
        <FormDateTimeColumn
          dateLabel="Date From:"
          timeLabel="Time From:"
          dateName="obDateFrom"
          timeName="obTimeFrom"
          valueDate={formData.obDateFrom}
          valueTime={formData.obTimeFrom}
          onChange={handleChange}
        />

        {/* Right Column */}
        <FormDateTimeColumn
          dateLabel="Date To:"
          timeLabel="Time To:"
          dateName="obDateTo"
          timeName="obTimeTo"
          valueDate={formData.obDateTo}
          valueTime={formData.obTimeTo}
          onChange={handleChange}
        />

        {/* Reason Field */}
        <ReasonField
          value={formData.reason}
          onChange={(value) => handleChange("reason", value)}
          fieldName={"Business Application"}
        />

        {/* File Upload */}
        <FileUpload onUpload={(file) => setFileAttached(file)} />

        <button type="submit" className="submit-btn">
          Submit Application
        </button>
      </form>
    </div>
  );
}

export default BusinessApplicationLayout;
